import { IconNameV1 } from 'common/icon/iconV1.js';

export enum Rainfall {
  NONE = 'rainfall-1-none',
  LIGHT = 'rainfall-2-light',
  MODERATE = 'rainfall-3-moderate',
  HEAVY = 'rainfall-4-heavy',
  TORRENTIAL = 'rainfall-5-torrential',
  GENERAL = 'rainfall-general',
}

export enum Snowfall {
  GENERAL = 'snowfall-general',
}

export enum WindChill {
  GENERAL = 'wind-chill',
}

type TableIcons = Rainfall | Snowfall | WindChill;

export function getTableIconName(tableIconEnum: TableIcons | undefined): IconNameV1 {
  if (tableIconEnum) {
    return `${tableIconEnum}` as IconNameV1;
  }
  return '' as IconNameV1;
}
